import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';

@Component({
  selector: 'app-optimization-popup',
  templateUrl: './optimization-popup.component.html',
  styleUrls: ['./optimization-popup.component.scss'],
})
export class OptimizationPopupComponent {

  client = 'ALL';

  cargoTypes: string[] = [
    'Veg Oil',
    'Crude Oil'
  ];

  segments: any[] = [];
  operations: any[] = [];
  ports: any[] = [];
  filteredPorts: any[] = [];

  filters: any = {
    segment: '',
    operation: '',
    port: '',
    cargoQty: '',
    oil: ''
  };

  result: any;

  isLoading: boolean = false;
  isDropdownLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<OptimizationPopupComponent>,
    private pRequestformService: PortRequestFormServiceService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getSegments();
  }

  close() {
    this.dialogRef.close();
  }

  /* ---------------- SEGMENTS ---------------- */

  getSegments() {

    this.isDropdownLoading = true;

    this.pRequestformService.getSegmentsName().subscribe(
      (res: any) => {

        this.segments = res.segments || [];

        this.isDropdownLoading = false;

      },
      (error) => {

        this.isDropdownLoading = false;
        console.error(error);

      }
    );
  }

  /* ---------------- OPERATIONS ---------------- */

  onSegmentChange() {

  this.isDropdownLoading = true;

  const jsonData = {
    segment: Array.isArray(this.filters.segment)
      ? this.filters.segment
      : [this.filters.segment]
  };

  this.pRequestformService.getOptimizationOperations(jsonData).subscribe(
    (res: any) => {

      this.operations = res.operations || [];

      this.isDropdownLoading = false;

    },
    (error) => {

      this.isDropdownLoading = false;
      console.error(error);

    }
  );
}

  /* ---------------- PORTS ---------------- */

  onOperationChange() {

  this.isDropdownLoading = true;

  const jsonData = {
   // client: this.client,
    segment: this.filters.segment,
    operation: this.filters.operation
  };

  this.pRequestformService
    .  getOptimizationNamePorts(jsonData)
    .subscribe(
      (res: any) => {

        this.ports = Object.keys(res.ports || {}).map(key => ({
          name: key,
          value: key
        }));

        this.filteredPorts = [...this.ports];

        this.isDropdownLoading = false;

      },
      (error) => {

        this.isDropdownLoading = false;
        console.error(error);

      }
    );
}

  /* ---------------- AUTOSUGGEST ---------------- */

  filterPorts(event: any) {

    const value = event.target.value?.toLowerCase() || '';

    this.filteredPorts = this.ports.filter((port: any) =>
      port.name.toLowerCase().includes(value)
    );
  }

  showAllPorts() {
    this.filteredPorts = [...this.ports];
  }

  selectPort(port: any) {
    this.filters.port = port.name;
  }

  /* ---------------- OPTIMIZATION API ---------------- */

  calculateOptimization() {

    this.result = null;

    this.isLoading = true;

    const jsonData = {

      segment: this.filters.segment,

      operation: this.filters.operation,

      port_name: [this.filters.port],

      expected_cargo_qty: this.filters.cargoQty,

      oil: this.filters.oil

    };

    this.pRequestformService.getOptimization(jsonData).subscribe(

      (res: any) => {

        this.result = res;

        this.isLoading = false;

      },

      (error) => {

        this.isLoading = false;

        this.toastr.error(
          error?.error?.message || 'No data found for selected ports',
          'Optimization Error'
        );

      }
    );
  }

}